import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from '@/app/App'
import ErrorBoundary from '@/components/ErrorBoundary'
import { AuthProvider } from '@/hooks/useAuth'
import '@/config/firebase' // efeito colateral: inicia Firebase + App Check
import '@/styles/global.css'
import { initTheme } from '@/hooks/useTheme'

// Aplica tema (claro/escuro/auto) ANTES do React renderizar — evita o
// "flash" de tema errado quando o usuário tem light salvo.
initTheme()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
